"use client";
import * as React from "react";
import { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ListedExperience from "./ListedExperience";
import ExperienceContext from "@/context/experienceContext";
import { ExperienceObj } from "@/app/@types/experienceobj";
import SurveyDataContext from "@/context/surveyDataContext";
import QCategoryContext from "@/context/qcategoryContext";

/**
 * A React child component that retrieves the available YEX experiencs and
 * displays the active experience options by Deep On / Deep Off category.
 *
 * @remarks
 * The component calculates the experience options based upon the answers
 * provided in the survey page based upon the yes selections, or randomly
 * if all questions are answered "no".  The component uses the React Context
 * API to retreive the survey results, the experience options, as well as the
 * categories that the questions fall into (used by the experience selection
 * algorithm).  The component is a parent to the Experience component and child
 * to the RecPannel component.
 * The component displays all experiences by Deep On or Deep Off Catergory,two
 * experiences per row.
 *
 * @param props - React props used to determine if component should display
 *                the Deep On or Deep Off or Coming Next Month category.
 * @returns - The CategoryPannelInner React component in JSX.
 */
export default function CategoryPanelInner(props: any) {
  const [experiences, setExperiences] = useState(
    null as ExperienceObj[] | null | undefined
  );

  // const { surveyData } = useContext(SurveyDataContext);
  const qcategories = useContext(QCategoryContext);
  const fetchedExs = useContext(ExperienceContext);

  const categoryPanelType = props.categoryPanelType;

  // console.log("In RecPanelInner");
  // console.log(survey);
  // console.log(secondary);
  // console.log(qcategories);

  useEffect(() => {
    if (fetchedExs != null) {
      console.log("Inside useEffect");
      console.log("fetchedExs", fetchedExs);
      // Filter experiences where active = true and category = "DEEP OFF"
      if (categoryPanelType === "deepOff") {
        const filteredExperiences = fetchedExs.filter(
          (experience) =>
            experience.active && experience.category === "DEEP OFF"
        );
        setExperiences(filteredExperiences);
        console.log("filteredExperiences deepOff", filteredExperiences);
      } else if (categoryPanelType === "deepOn") {
        const filteredExperiences = fetchedExs.filter(
          (experience) => experience.active && experience.category === "DEEP ON"
        );
        setExperiences(filteredExperiences);
        console.log("filteredExperiences deepOn", filteredExperiences);
      } else if (categoryPanelType === "comingNextMonth") {
        console.log("Inside coming next month");
        // Filter experiences where comingNextMonth = true and category = "DEEP OFF"
        const filteredExperiences = fetchedExs.filter(
          (experience) => experience.comingNextMonth
        );
        setExperiences(filteredExperiences);
        console.log("filteredExperiences comingNextMonth", filteredExperiences);
      }
      // Set the experiences state to the filtered experiences
    }
  }, [fetchedExs, categoryPanelType]);

  if (experiences == null) {
    return <Box>Loading...</Box>;
  }

  const cardCount = experiences.length;
  // Determine grid size per card
  let gridSize = 4; // default for 3 per row
  // leave box width and height for now, but not really used
  let boxWidthPercent = "100%";
  let boxHeightPercent = "100%";
  if (cardCount === 1) gridSize = 12;
  else if (cardCount === 2) gridSize = 6;
  else if (cardCount === 4) {
    gridSize = 6; // 2 per row for 4 cards
    boxWidthPercent = "75%";
    boxHeightPercent = "65%";
  }

  return (
    <Box sx={{ bgcolor: "secondary.dark" }}>
      <Grid
        container
        columnSpacing="5"
        rowSpacing="3"
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        style={{ marginTop: "5px" }}
      >
        {experiences.map((experience, index) => (
          <Grid
            item
            xs={12}
            sm={gridSize}
            md={gridSize}
            key={experience.id || index}
          >
            <ListedExperience {...experience} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
